import './olfactive-family.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initOlfactiveFamily = (context) => {
  const olfactiveFamilySection = context.closest('.shopify-section');

  if (!olfactiveFamilySection) return;
  const olfactiveFamilySectionWrapper = olfactiveFamilySection.querySelector('.olfactive-family__spacing-wrapper');
  const firstElement = olfactiveFamilySectionWrapper.querySelectorAll('.olfactive-family__tab-element')[0];

  const desktopTabs = olfactiveFamilySection.querySelectorAll('.olfactive-family__tab-title[data-tab-index]');
  if (desktopTabs.length > 0) {
    desktopTabs.forEach(desktopTab => {
      desktopTab.addEventListener('click', () => {
        const index = desktopTab.dataset.tabIndex;
        const tabContent = olfactiveFamilySection.querySelector(`.olfactive-family__tab-contents[data-tab-index="${index}"]`);
        const openTabs = olfactiveFamilySection.querySelectorAll(`.olfactive-family__tab-contents.open:not([data-tab-index="${index}"])`);
        const activeTabs = olfactiveFamilySection.querySelectorAll(`.olfactive-family__tab-title.active:not([data-tab-index="${index}"])`);
        const backgroundColor = tabContent.querySelector(`.olfactive-family__tab-element:first-child`).getAttribute('data-background_color');

        if (tabContent && !tabContent.classList.contains('open')) {
          if (openTabs.length > 0) {
            openTabs.forEach(openTab => {
              openTab.classList.remove('open');
            });
          }
          tabContent.classList.add('open');

          if (activeTabs.length > 0) {
            activeTabs.forEach(activeTab => {
              activeTab.classList.remove('active');
            });
            desktopTab.classList.add('active');
          }
        }

        if (backgroundColor) {
          olfactiveFamilySectionWrapper.style.backgroundColor = backgroundColor;
        }
      });
    });
  }

  if (firstElement.getAttribute('data-background_color')) {
    olfactiveFamilySectionWrapper.style.backgroundColor = firstElement.getAttribute('data-background_color');
  }

  const mobileTabs = olfactiveFamilySection.querySelectorAll('.olfactive-family__tabs-container--mobile .olfactive-family__tab');
  if (mobileTabs.length) {
    Array.from(mobileTabs).map(el => {
      el.addEventListener('click', e => {
        let bgColor;

        if (e.target.hasAttribute('data-background_color')) {
          bgColor = e.target.getAttribute('data-background-color');
        } else {
          const firstColor = el.querySelector('[data-background_color]');
          if (firstColor) bgColor = firstColor.getAttribute('data-background_color');
        }

        if (bgColor) olfactiveFamilySectionWrapper.style.backgroundColor = bgColor;
      });
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.olfactive-family__container'), (el) => {
    window.dAgency.initOlfactiveFamily(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.olfactive-family__container'), (el) => {
      window.dAgency.initOlfactiveFamily(el);
    });
  });
}
